<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{ 'content-nav-active': newstype == 1 }"
            @click="newstype = 1"
          >
            <span>智慧养老</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item, index) in newsList" :key="index">
            <div class="item-img">
              <img :src="item.Img" alt="" />
            </div>
            <p class="item-list-title">{{ item.Title }}</p>
            <p class="item-list-content">{{ item.Content }}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'QixieDetails', params: { id: item.Id } }"
              >
                <img src="@/assets/img/sanjiao.png" />
                <span>查看详情</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
export default {
  name: "news",
  components: {
    Banner,
  },
  data() {
    return {
      loading: false,
      newsList: [
        {
          Id: "1",
          Title: "老年人轮椅",
          Img: require("@/assets/img/QiXie1.png"),
          CreateTime: "2024-04-16 17:51",
          Content:
            "轮椅是装有轮子可以帮助替代行走的椅子，是用于伤员、病员、残疾人居家康复、周转运输、就诊、外出活动的重要移动工具。轮椅不仅满足肢体伤残者和行动不便人士的代步需求，更重要的是方便家属移动和照顾病员，使病员借助于轮椅进行身体锻炼和参与社会活动。",
        },
        {
          Id: "2",
          Title: "血糖仪",
          Img: require("@/assets/img/QiXie2.png"),
          CreateTime: "2024-04-22 18:05",
          Content:
            "血糖仪又称血糖计，是一种测量血糖水平的电子仪器。血糖仪从工作原理上分为光电型和电极型两种。电极型血糖仪的测试原理更科学，电极可内藏。",
        },
        {
          Id: "3",
          Title: "血压仪",
          Img: require("@/assets/img/QiXie3.png"),
          CreateTime: " 2024-06-07 15:44",
          Content:
            "血压仪是测量血压的仪器，也叫血压计。按测量血压的设计原理来区分主要有听诊法血压计和示波法血压计。",
        },
      ],
      newstype: 1,
    };
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.news {
  width: 100%;
  height: 100%;
  background-color: rgb(255, 118, 64, 0.9);
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
          }
          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>